import * as types from "./types";

export const getCompanyActivityLogsRequest = (payload) => ({
  type: types.GET_COMPANY_ACTIVITY_LOGS_REQUEST,
  payload,
});

export const getCompanyActivityLogsResponse = (payload) => ({
  type: types.GET_COMPANY_ACTIVITY_LOGS_RESPONSE,
  payload,
});

export const getCompanyActivityLogsFailure = () => ({
  type: types.GET_COMPANY_ACTIVITY_LOGS_FAILURE,
});
